export const ExportFormatType = {
  NoFormat: 0,
  CrystalReport: 1,
  RichText: 2,
  WordForWindows: 3,
  Excel: 4,
  PortableDocFormat: 5,
  HTML32: 6,
  HTML40: 7,
  ExcelRecord: 8,
  Text: 9,
  CharacterSeparatedValues: 10,
  TabSeperatedText: 11,
  EditableRTF: 12,
  Xml: 13,
  RPTR: 14,
  ExcelWorkbook: 15,
};



// WEBPACK FOOTER //
// ./src/common/Constants/Enumeration/ExportFormatType.js